/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getGlobalBridgeAdminMast = `query GetGlobalBridgeAdminMast($sub: String!) {
  getGlobalBridgeAdminMast(sub: $sub) {
    editAdmin
    getAdmin
    getChildminder
    getRecord
    name
    name_kana
    sub
    isDeleted
    editNotification
  }
}
`;
export const getGlobalBridgeContactBookRecord = `query GetGlobalBridgeContactBookRecord($child: String!, $createdAt: String!) {
  getGlobalBridgeContactBookRecord(child: $child, createdAt: $createdAt) {
    hBreakfast
    child
    createdAt
    hDefecation
    hDefecationTime
    sDefecationState
    sDefecationTime
    hDinner
    sMealType
    sMealAmount
    sMealMenu
    sEvent
    hComment
    hMilk
    hMilkTime
    sMilk
    sMilkTime
    sSleepTotal
    sSleepEnd
    sSleepFrom
    nurseId
    nurseName
    sComment
    hSleepEnd
    hSleepFrom
    hSleepTotal
    sTemperature
    sTemperatureTime
    hTemperature
    hTemperatureTime
    sClassComment
  }
}
`;
export const getGlobalBridgeParentChildMast = `query GetGlobalBridgeParentChildMast($childId: Int!, $sub: String!) {
  getGlobalBridgeParentChildMast(childId: $childId, sub: $sub) {
    childId
    sub
  }
}
`;
export const listGlobalBridgeAdminMast = `query ListGlobalBridgeAdminMast(
  $filter: TableGlobalBridgeAdminMastFilterInput
  $limit: Int
  $nextToken: String
) {
  listGlobalBridgeAdminMast(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      editAdmin
      getAdmin
      getChildminder
      getRecord
      name
      name_kana
      sub
      isDeleted
      editNotification
    }
    nextToken
  }
}
`;
export const listGlobalBridgeSchoolMast = `query ListGlobalBridgeSchoolMast(
  $filter: TableGlobalBridgeSchoolMastFilterInput
  $limit: Int
  $nextToken: String
) {
  listGlobalBridgeSchoolMast(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      isVevo
      isEnableVevo
      noteTimeLimit
      isMemoruEnabled
      isDiaryEnabled
    }
    nextToken
  }
}
`;
export const listGlobalBridgeContactBookRecord = `query ListGlobalBridgeContactBookRecord(
  $filter: TableGlobalBridgeContactBookRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  listGlobalBridgeContactBookRecord(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      hBreakfast
      child
      createdAt
      hDefecation
      hDefecationTime
      sDefecationState
      sDefecationTime
      hDinner
      sMealType
      sMealAmount
      sMealMenu
      sEvent
      hComment
      hMilk
      hMilkTime
      sMilk
      sMilkTime
      sSleepTotal
      sSleepEnd
      sSleepFrom
      nurseId
      nurseName
      sComment
      hSleepEnd
      hSleepFrom
      hSleepTotal
      sTemperature
      sTemperatureTime
      hTemperature
      hTemperatureTime
      sClassComment
    }
    nextToken
  }
}
`;
export const listGlobalBridgeParentChildMast = `query ListGlobalBridgeParentChildMast(
  $filter: TableGlobalBridgeParentChildMastFilterInput
  $limit: Int
  $nextToken: String
) {
  listGlobalBridgeParentChildMast(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      childId
      sub
    }
    nextToken
  }
}
`;
export const listGlobalBridgeMaintenanceMessage = `query ListGlobalBridgeMaintenanceMessage(
  $filter: TableGlobalBridgeMaintenanceMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  listGlobalBridgeMaintenanceMessage(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      startDt
      endDt
      isEnabled
      message
    }
    nextToken
  }
}
`;
export const listGlobalBridgeCcsMast = `query ListGlobalBridgeCcsMast(
  $filter: TableGlobalBridgeCcsMastFilterInput
  $limit: Int
  $nextToken: String
) {
  listGlobalBridgeCcsMast(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      serverId
      nurseryCode
      createdAt
    }
    nextToken
  }
}
`;



// WEBPACK FOOTER //
// ./src/graphql/queries.js